var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if an associative array value for `key` exists.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function assocHas(array, key) {
  return assocIndexOf(array, key) > -1;
}

module.exports = assocHas;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-relay/~/lodash/_assocHas.js
 ** module id = 272
 ** module chunks = 0
 **/